module.exports = __webpack_public_path__ + "static/media/FreeFire.c84e2018.png";